import * as React from 'react';
import { observer } from 'mobx-react-lite';

let styles = require('owa-calendar-surface-dategrid/lib/surfaceItems/CalendarDateHeader.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CalendarMonthDateHeaderProps {
    header: string;
}

/**
 * This panel shows date headers for surface columns
 */
const CalendarMonthDateHeader = observer(function CalendarMonthDateHeader(
    props: CalendarMonthDateHeaderProps
) {
    const { header } = props;
    // in month view we want the headers to be equally spaced, so just use flex: 1 (which evenly distributes all children to space available)
    const style = {
        position: 'relative' as 'relative', // required because typescript doesn't recognize string as type 'relative', so force declaration
        flex: 1,
    };

    return (
        <div className={classNames(styles.header, styles.monthHeader)} style={style}>
            <time title={header}>{header}</time>
        </div>
    );
});
export default CalendarMonthDateHeader;
